import { render, staticRenderFns } from "./PasswordResetFormItem.vue?vue&type=template&id=152037ea&"
import script from "./PasswordResetFormItem.vue?vue&type=script&lang=js&"
export * from "./PasswordResetFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('152037ea')) {
      api.createRecord('152037ea', component.options)
    } else {
      api.reload('152037ea', component.options)
    }
    module.hot.accept("./PasswordResetFormItem.vue?vue&type=template&id=152037ea&", function () {
      api.rerender('152037ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PasswordResetFormItem.vue"
export default component.exports